module.exports = __webpack_public_path__ + "static/media/presidente.24f8d4cd.jpg";